export default __webpack_public_path__ + "static/media/1159.2767d9f1.png";